import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { Wrapper } from 'hb-builder/components/common/Wrapper';
import { RendererProvider } from 'hb-builder/contexts';
import {
  useBuilderContext,
  useComponentContext,
  useComponentsContext,
  useBuilderConfigContext,
} from 'hb-builder/hooks';
import type { BuilderComponent } from 'hb-builder/types';

const EmailMirrorLink: BuilderComponent = () => <div />; // never used

const RenderBuilder = () => {
  const { getBodyItem } = useBuilderContext();
  const { item } = useComponentContext();
  const { components } = useComponentsContext();
  const {
    features: { workspace: workspaceConfig },
    hivebrite: { ids },
  } = useBuilderConfigContext();

  const { Column, Section } = components;

  const { bodyWidth } = getBodyItem().attributes;

  return (
    <RendererProvider
      bodyWidth={bodyWidth}
      ids={ids}
      isMobilePreview={false}
      isPublic={false}
      workspaceConfig={workspaceConfig}
    >
      {/* @ts-expect-error Wrapper is not typed */}
      <Wrapper>
        <Section.Render item={item} workspaceConfig={workspaceConfig}>
          <Column.Render>
            <StyledMirrorLink
              dangerouslySetInnerHTML={{
                __html: item.attributes?.mirrorLinkTemplate,
              }}
              style={{
                margin: '0 auto',
                width: bodyWidth,
              }}
            />
          </Column.Render>
        </Section.Render>
      </Wrapper>
    </RendererProvider>
  );
};

const Render = () => <div />;

EmailMirrorLink.componentName = 'EmailMirrorLink';
EmailMirrorLink.componentType = 'section';

EmailMirrorLink.componentLabel = __('Mirror Link');

EmailMirrorLink.canBeDoubleClicked = true;
EmailMirrorLink.canBeDragged = false;
EmailMirrorLink.canBeListed = false;
EmailMirrorLink.canBeSelected = true;

EmailMirrorLink.Render = Render;
EmailMirrorLink.RenderBuilder = RenderBuilder;

EmailMirrorLink.item = ({ mirrorLinkTemplate }) => ({
  attributes: {
    mirrorLinkTemplate,
    readOnly: true,
  },
  content: '%{Mirror_Link}',
  type: EmailMirrorLink.componentName,
});

export default EmailMirrorLink;

const StyledMirrorLink = styled(Box)`
  a {
    cursor: pointer;
    pointer-events: none !important;
  }
`;
